/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespShippingReturns_shipmentQuote$ref = any;
type PdpRespSidebarBlurbs_shipmentQuote$ref = any;
export type PdpRespContainer_shipmentQuote$ref = any;
export type PdpRespContainer_shipmentQuote = {
    readonly " $fragmentRefs": PdpRespSidebarBlurbs_shipmentQuote$ref & PdpRespShippingReturns_shipmentQuote$ref;
    readonly " $refType": PdpRespContainer_shipmentQuote$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpRespContainer_shipmentQuote",
    "type": "ShipmentQuote",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarBlurbs_shipmentQuote",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpRespShippingReturns_shipmentQuote",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'efb9d699ed292459b86b63bb220d8246';
export default node;
